import headerOptions from '../TheHeader/TheHeader.options'

const options = Object.assign({}, headerOptions, { name: 'SubbrandHeader' })
export default options
